// update baseURL to point to correct codebase
export const FEEDBACK_BASE_URL = 'https://github.com/konflux-ci/support/issues/new?';

export enum FeedbackSections {
  BeginningSection = 'BeginningSection',
  FeedbackSection = 'FeedbackSection',
  BugSection = 'BugSection',
  FeatureSection = 'FeatureSection',
}
